import { Component, EventEmitter, HostListener, OnDestroy, Output } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

import { WorkSheet, WorkBook, utils, read } from "xlsx";
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { Subject } from "rxjs";

@Component({
  selector: "app-bulk-dialog-upload",
  templateUrl: "./bulk-dialog-upload.component.html",
  styleUrls: ["./bulk-dialog-upload.component.scss"],
})
export class BulkDialogUploadComponent implements OnDestroy {
  constructor(private snackBar: MatSnackBar) {}
  extention: string;
  isHovered: boolean;
  actions: any;
  private destroy$ = new Subject<void>();
  @Output() data: EventEmitter<any> = new EventEmitter();

  @HostListener("dragover", ["$event"]) public onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.isHovered = true;
  }

  @HostListener("dragleave", ["$event"]) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.isHovered = false;
  }

  @HostListener("drop", ["$event"]) public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    let files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.handleFileInput(evt.dataTransfer.files);
    }
  }

  // Starting code for pasting
  // @HostListener('paste', ['$event'])
  // onPaste(e: ClipboardEvent) {
  //   let clipboardData = e.clipboardData;
    
  //   let pastedText = clipboardData.getData('text');
  //   this.handlePaste(pastedText);
  // }
  // handlePaste(pastedText) {
  //   let data = this.parseFromExcel(pastedText);
    
  //   if (data) {
  //     this.data.emit(data);
  //   }
  // }
  handleFileInput(event) {
    if (typeof event === "object") {
      const file = event[0];
      this.extention = file.name.split(".")[file.name.split(".").length - 1];

      const allowedExtensions = ["CSV", "XLSX", "XLSM"];
      if (allowedExtensions.includes(this.extention.toUpperCase())) {
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = (evt) => {    
          let data = this.parseFromExcel(evt.target.result);  
          if (!data.length) {
            this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 3000,
                  horizontalPosition: 'center',
                  data: {
                    title: 'File contains header row only, please try again',
                    action: 'Dismiss',
                    type: 'error',
                  },
                }
            );
          } else {
            this.data.emit(data);
          }
        };
        reader.onerror = function (evt) {
        };
      } else {
        this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'Please upload csv or xlsx file',
                action: 'Dismiss',
                type: 'info',
              },
            }
        );
      }
    }
  }

  parseFromExcel(file) {
    const workbook: WorkBook = read(file, {type:"binary", raw: true});
    const wsname: string = workbook.SheetNames[0];
    const ws: WorkSheet = workbook.Sheets[wsname];
    let tableData;
    try {
      tableData = utils.sheet_to_json(ws, {raw: false, rawNumbers: false});
    } catch (error) {
      console.error("Error processing sheet:", error);
    }
    return tableData;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
